import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_3 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_4 = { class: "sm:col-span-4" }
const _hoisted_5 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_6 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4 text-center" }

import { ref, Ref, computed, watch } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';

import {
    MultiSelectOption,
    ConnectFlowAudioGetters,
    ConnectFlowAudioActions,
    ConnectFlowAudioFilter,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowAudioListFilters',
  setup(__props) {

const { t } = useI18n();

const filtersOpened = ref(false);

const defaultFilter = computed(() => store.getters[ConnectFlowAudioGetters.DEFAULT_FILTER]);

const filter: Ref<ConnectFlowAudioFilter> = ref({
    isActive: defaultFilter.value.isActive,
});

const storeFilters = computed<ConnectFlowAudioFilter>(
    () => store.getters[ConnectFlowAudioGetters.FILTER],
);

const isActiveFilterOptions = [
    {
        label: t('connectFlowAudio.filters.isActive.options.active'),
        value: true,
    },
    {
        label: t('connectFlowAudio.filters.isActive.options.inactive'),
        value: false,
    },
] as MultiSelectOption[];

function applyFilters() {
    store.dispatch(ConnectFlowAudioActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(ConnectFlowAudioActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    filter.value.isActive = storeFilters.value.isActive;
}

watch(filtersOpened, () => {
    refreshLocalFilter();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filtersOpened.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        class: "hover:bg-gray-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filtersOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-0 h-5 w-5 text-gray-400 sm:mr-3",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('connectFlowAudio.filters.isActive.label')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filters_isActive",
              modelValue: filter.value.isActive,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.isActive) = $event)),
              options: isActiveFilterOptions,
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})